<template>
	<span @click="submitUpdateAsinInfo(null)">
		<slot>
			<span class="el-icon-refresh" style="cursor: pointer;"></span>
		</slot>
	</span>
</template>

<script>
import { api_asin_updateAsinInfo } from "@/components/api/asinBasiceInfo";

export default {
	name: "refreshAsinData",
	inject: ['WINDOW', 'F_alertMsg', 'F_windowLoading', 'F_getErrMSg', 'F_LOGIN', 'LOGINUSER'],
	data() {
		return {
			windowObj: this.WINDOW,
			loginUser: this.LOGINUSER,
			loading : false
		};
	},
	props : {
		asin : {
			required  : true
		},
		country : {
			default : 'us'
		}
	},
	created() {

	},
	methods: {
		submitUpdateAsinInfo : function(this_) {
			this_ = this_ || this
			//开启遮罩
			// this_.F_windowLoading(true,{ text : '正在提交任务' })
			api_asin_updateAsinInfo(this_.asin).then(res => {
				this_.F_alertMsg("发送商品检索任务成功", 2)
				// 关闭遮罩
				// this_.F_windowLoading(false,null)
			}).catch(err => {
				// 关闭遮罩
				// this_.F_windowLoading(false,null)
				this_.F_alertMsg(this_.F_getErrMSg(err, "发送商品检索任务失败"), 4)
			})
		},


	}, watch: {
		windowObj: {
			handler() {
			},
			deep: true
		},
		loginUser: {
			handler() {
			},
			deep: true
		}
	}
}
</script>

<style scoped>

</style>